<template>
  <vs-select
    val-icon-success="done"
    val-icon-danger="error"
    :danger="errors.first(name) ? true : false"
    :name="name"
    :danger-text="errors.first(name)"
    :data-vv-as="name"
    :label="label"
    class="w-full square-select"
    v-model="internalValue"
  >
    <vs-select-item
      v-for="(opt, index) in options"
      :key="index"
      :value="opt.value"
      :text="opt.label"
    />
  </vs-select>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style>
.square-select > div > input {
  border-radius: 5px !important;
  margin-top: 4px;
}
</style>
